import RootRouters from './routers/RootRouters';
import './assets/styles/main.scss';
import { TrenerNameProvider } from './components/ModalCalendar/TrenetNameContext';
import './i18n';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <>
      <TrenerNameProvider>
        <RootRouters />
        <Toaster
          position="top-right"
          reverseOrder={false}
          containerStyle={{ zIndex: 20000 }}
        />
      </TrenerNameProvider>
    </>
  );
}

export default App;
